export default __webpack_public_path__ + "images/models/5d5b16d5e176c49891ca66e9e82f531e.glb";